module.exports = __webpack_public_path__ + "img/banner@2x.cfd6b5f0.png";